import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../Common/InputText';
import Toggle from '../../Common/Toggle/Toggle';

export default class CommunityForm extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    onTextChange = (e) => {
        this.props.onFormChange(e.target.name, e.target.value);
    }

    onToggleChange = (name, value) => {
        this.props.onFormChange(name, value);
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit();
        return false;
    }

    render() {

        const alertClassList = (this.props.showWarning) ? "alert alert-warning" : "d-none";

        return (
            <div className="identifier-form">
                <form noValidate className={this.props.isFormValid ? "" : "was-validated"} onSubmit={this.onSubmit} >
                    <InputText name="name" label="Name" placeholder="Name" type="text" value={this.props.community.name} onChange={this.onTextChange} isRequired={true} errorMessage="Name is required" />
                    <Toggle name="isActive" text="Active" checked={this.props.community.isActive} onChange={this.onToggleChange} />
                    <div className={alertClassList} role="alert">Be careful: Tasks assigned to inactive Communities will longer appear on task lists.</div>
                </form>
            </div>
        );
    }

}


CommunityForm.propTypes = {
    onFormChange: PropTypes.func.isRequired, // returns (field, value)
    isFormValid: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    showWarning: PropTypes.bool.isRequired,
    community: PropTypes.object
}

